import { render, staticRenderFns } from "./XExcelExportButton.vue?vue&type=template&id=5fc1a0d0"
import script from "./XExcelExportButton.vue?vue&type=script&lang=js"
export * from "./XExcelExportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports